import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchFlashcards, createFlashcard } from "../services/courseService";

export const useFlashcards = (courseId) => {
  const queryClient = useQueryClient();

  const getFlashcards = useQuery({
      queryKey: ['flashcards', courseId],
      queryFn: () => fetchFlashcards(courseId),
    });

  const createFlashcards = useMutation({
      mutationFn: (newData) => createFlashcard(courseId, newData),
      onSuccess: () => {
        queryClient.invalidateQueries(['flashcards', courseId]);
      },
    });

  return { getFlashcards, createFlashcards };
};
